import type { IconProps } from "@/types/icon";

const ChevronDown = ({ color = "black", className }: IconProps) => (
  <svg
    width="13"
    height="14"
    viewBox="0 0 13 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M3.93237 5.48877L6.95487 8.51127L9.97737 5.48877"
      stroke={color}
      strokeWidth="1.209"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ChevronDown;
